//https://github.com/aptos-labs/aptos-ts-sdk/blob/main/src/core/accountAddress.ts#L4
function isValidAptosAddress(address) {
  const maxMissingChars = 4;
  let parsedInput = address;

  if (!address.startsWith("0x")) {
    return false;
  }

  parsedInput = address.slice(2);
  if (parsedInput.length === 0 || parsedInput.length > 64) {
    return false;
  }

  let addressBytes;
    try {
      // Pad the address with leading zeroes, so it is 64 chars long and then convert
      // the hex string to bytes. Every two characters in a hex string constitutes a
      // single byte. So a 64 length hex string becomes a 32 byte 
      // array.
      addressBytes = hexToBytes(parsedInput.padStart(64, "0"));
  } catch (error) {
    return false;
  }

  if (addressBytes.length !== 32) {
    return false;
  }

  if(parsedInput.length < 64 - maxMissingChars) {
    if (!isSpecial(addressBytes)) {
      return false;
    }
  }

  return true;
}

function isSpecial(addressBytes) {
  console.log(addressBytes.slice(0, addressBytes.length - 1));
  return addressBytes.slice(0, addressBytes.length - 1).every((byte) => byte === 0) && addressBytes[addressBytes.length - 1] < 0b10000;
}

function hexToBytes(hex) {
  const bytes = [];
  for (let i = 0; i < hex.length - 1; i += 2) {
      bytes.push(parseInt(hex.substr(i, 2), 16));
  }
  return bytes;
}

export default {
  isValidAddress(address) {
    return isValidAptosAddress(address);
  }
};
